import { useMemo } from 'react'
import { dateDifference } from 'lib/datetime/dateUtils'
import { TOUR_OPTIONAL_EXPERIENCE_BOOKING_DAYS_BEFORE_DEPARTURE } from 'constants/tours'

export default function usePurchasableTourOptionalExperience(
  tourItem: App.Tours.TourV2OrderItem,
  tourOffer: App.Tours.TourV2Offer | undefined,
  snapshot: App.Tours.TourV2OfferSnapshot | undefined,
): boolean {
  const hasOptionalExperiencesStillPurchasable = useMemo(() => {
    if (tourOffer && tourItem && snapshot) {
      const purchasableExperienceOptions = tourOffer.purchasableExperienceOptions ? Object.values(tourOffer.purchasableExperienceOptions) : []
      const daysBeforeDeparture = tourOffer.optionalExperienceBookingDaysBeforeDeparture ?? TOUR_OPTIONAL_EXPERIENCE_BOOKING_DAYS_BEFORE_DEPARTURE
      const isAvailableForBookingOptionalExperience = dateDifference(new Date(tourItem.tour.startDate)).days >= daysBeforeDeparture
      const hasOptionalExperiences = purchasableExperienceOptions.length > 0
      const alreadyBookedOptionalExperiences = purchasableExperienceOptions.every(purchasableOptionalExperience => {
        return (purchasableOptionalExperience.dayNumbers || []).every(dayNumber => {
          return !!snapshot.optionalExperiences?.find(
            orderExperienceItem => orderExperienceItem.dayNumber === dayNumber && orderExperienceItem.id === purchasableOptionalExperience.fkExperienceId,
          )
        })
      })
      return hasOptionalExperiences && isAvailableForBookingOptionalExperience && !alreadyBookedOptionalExperiences
    }
    return false
  }, [tourItem, tourOffer, snapshot])
  return hasOptionalExperiencesStillPurchasable
}
